import React from 'react';
import styled from 'styled-components';

import { MapButton, ArrowBack } from '@lt/components/icons-react/map';
import { pushMapExpanded } from '../../analitics';

interface ToggleMapButtonProps {
  toggleHandler: () => void;
  mapView: boolean;
  className?: string;
}

export const ToggleMapButtonMobile = (
  props: ToggleMapButtonProps,
): JSX.Element => {
  const { toggleHandler, mapView, className } = props;

  const handleClick = () => {
    toggleHandler();

    pushMapExpanded(mapView);
  };

  return (
    <Container className={className}>
      <Button onClick={handleClick}>
        {!mapView && <MapButton width={46} />}
        {mapView && <ArrowBack width={20} />}
      </Button>
    </Container>
  );
};
const buttonSize = '46px';
const Container = styled.div`
  width: ${buttonSize};
  height: ${buttonSize};
  border-radius: 50%;
  box-shadow: 0 5px 20px 0 rgba(21, 21, 21, 0.5);
`;

const Button = styled.button`
  padding: 0;
  width: ${buttonSize};
  height: ${buttonSize};
  background-color: #fff;
  border: 0;
  border-radius: 50%;
`;
